import { render } from "./BrandPortfolioPage.vue?vue&type=template&id=4deedc45"
import script from "./BrandPortfolioPage.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioPage.vue?vue&type=script&lang=js"

import "./BrandPortfolioPage.vue?vue&type=style&index=0&id=4deedc45&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__